'use client';
import { useEffect } from 'react';
import { usePreferences } from '@/lib/preferences';

const RTL_LANGS = new Set(['ar']);

export function HtmlDirSync() {
  const { prefs } = usePreferences();
  useEffect(() => {
    const html = document.documentElement;
    html.dir = RTL_LANGS.has(prefs.language) ? 'rtl' : 'ltr';
    html.lang = prefs.language;
  }, [prefs.language]);
  return null;
}
